module.exports = __webpack_public_path__ + "static/media/grid.a49d3666.jpg";